/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     nav{z-index:11;width:100vw;height:100vh;background-color:#fff;overflow-x:hidden;overflow-y:auto;display:flex;flex-direction:column;position:absolute}"];
export { styles as styles };
